import styled from 'styled-components';

export const BundleContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  width: 26.3rem;
  gap: 0.5rem;
  max-width: 64rem;
  border-radius: 0.8rem;
  background-color: #badaf7;
  padding: 0.4rem 0.4rem 2.6rem 0.4rem;
  position: relative;
`;

export const BundleItem = styled.div`
  position: relative;
  width: 12.5rem;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 0.5rem;
  height: 100%;
  background-color: #fff;
`;

export const CostWrapper = styled.div`
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 0.4rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  z-index: 100;
`;
